import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AddProductToCartForm";
import {LIST_SHOP_PRODUCTS_FOR_ACCOUNT} from "../../queries/sales";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddProductToCart} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {sellableGroups, applyGroups} from "../../lib/StockHelper";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "productSku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

function formatProducts(products) {
  return fromJS(products).map((x) => {
    return x.set("productTitle", `${x.get("productSku")} ${x.get("productTitle")}`);
  })
}

class AddProductToCartFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.addProductToCart(values.set("accountId", this.props.accountId).toJS())
      .then((response) => {
        if (response.data.addProductToCart.errors.length <= 0) {
          this.props.cancelAddProductToCart();
        } else {
          let errors = createValidationErrors(response.data.addProductToCart.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddProductToCart();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let products = formatProducts(applyGroups(fromJS(data.shopProductsForAccount), "productSku", "type"));
    return (
      <Form
        products={products}
        groups={sellableGroups()}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ADD_PRODUCT_TO_CART = gql`
  mutation addProductToCart($data: AddToCartInput!) {
    addProductToCart(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(LIST_SHOP_PRODUCTS_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ADD_PRODUCT_TO_CART, {
    props: ({ mutate }) => ({
      addProductToCart: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddProductToCartFormContainerWithData = withProductQuery(AddProductToCartFormContainer);

export default connect(null, {cancelAddProductToCart})(AddProductToCartFormContainerWithData);